import { EnrollmentSettings } from '@/features/tenants-settings/enrollment-settings'
import { verifyRoles } from '@/utils/verifyRoles';
import { createFileRoute } from '@tanstack/react-router'
import { getTenant } from '../../../../../requests/getTenant';

export const Route = createFileRoute(
  '/dashboard/tenants/$tenantId/(settings)/enrollment-settings',
)({
  component: EnrollmentSettings,
  head: () => ({
    meta: [
      {
        title:
          "Configurações de vínculo de dispositivo do servidor de autorização - Backoffice Detentora Iniciador",
      },
    ],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN"]),
  loader: async ({ context, params }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["tenant", params.tenantId],
      queryFn: async () => getTenant(params.tenantId),
    });
  },
})
